import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { isEmpty } from 'lodash'

import {
  fetchCallViewCounts,
  fetchCriteriaUpdateAuditEventsForOrg,
  fetchManagerAudit,
  fetchQAAnalystActivity,
} from '@/reducers/scorecards/scores.actions'
import { setFilter } from '@/reducers/scorecards/scorecards.redux'
import { getPlaceholderContent } from '@/utils/helpers'
import { MultiSelect } from '@/components/forms/MultiSelect'
import { FormField } from '@/components/forms/FormField'

import { ViewScoresFilters } from '../../ViewScoresFilters/ViewScoresFilters'

export const FiltersSection = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { data, filters, loading } = useSelector((state) => state.scorecards)

  const isCopilot = location.pathname.startsWith('/qa-copilot/')

  const handleSubmit = () => {
    dispatch(fetchManagerAudit(['qa_dispute', 'qa_manual_score'], isCopilot))
    dispatch(fetchCriteriaUpdateAuditEventsForOrg(isCopilot))
    dispatch(fetchQAAnalystActivity({ scorecardType: isCopilot ? 'copilot' : 'automated' }))
    dispatch(fetchCallViewCounts())
  }

  return (
    <ViewScoresFilters
      multiScorecard
      sticky={false}
      handleFilterSubmit={handleSubmit}
      hide={{
        sections: true,
        measures: true,
        criteria: true,
        isWin: true,
        agents: true,
        tags: true,
        dispositions: true,
      }}
    >
      <FormField data-testid="managers-dropdown">
        <label>Managers</label>
        <MultiSelect
          isSelectAll
          options={data.agents}
          disabled={loading.agents || isEmpty(data.agents)}
          loading={loading.agents}
          value={filters.managerIds}
          onChange={(value) => dispatch(setFilter('managerIds', value))}
          {...getPlaceholderContent(data, loading, 'agents')}
        />
      </FormField>
    </ViewScoresFilters>
  )
}
